import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../svgs/search.svg";
import Button from "../Button";

const SearchBar = ({
  variant,
  inputBackground,
  svgStrokeColor,
  borderColor,
  className,
  textSize,
  inputWidth,
  inputHeight,
  placeholderColor,
  searchName,
  onSearch,
  searchItem,
  setSearchItem,
  ...restProps
}) => {
  const [search, setSearch] = useState("")
  const variants = {
    rounded: "rounded-full",
    primary: "rounded-lg",
    secondaryxl: "rounded-xl",
    secondary: "rounded-md",
  };

  const inputBackgroundVariants = {
    white: "bg-white",
    blue: "bg-blue-200",
    grey: "bg-grey-200",
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setSearchItem(value);
    onSearch();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch();
      setSearchItem(search)
    }
  };

  return (
    <div
      className={`relative border ${borderColor} ${className}`}
      {...restProps}
    >
      <input
        type="text"
        placeholder="Search"
        className={`p-4 pl-6 ${inputBackgroundVariants[inputBackground]} placeholder-${placeholderColor} font-normal ${variants[variant]} text-${textSize} w-${inputWidth} h-${inputHeight} outline-none`}
        value={search}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      <Button
        varient="secondaryxl"
        className="absolute right-3 top-[8px] p-0 text-white "
        onClick={onSearch}
      >
        <SearchIcon fill={svgStrokeColor} />
      </Button>
    </div>
  );
};

export default SearchBar;
